interface Environment {
  domain: string
  hyperlinks: Hyperlinks
}

interface Hyperlinks {
  discord: string
  hostname: string
  nintendoClients: string
  playerId: string
  trackId: string
}

const hyperlinks: Hyperlinks = {
  discord: "https://discord.com/invite/zsv5h47dgT",
  hostname: "https://www.mkdatabase.com/",
  nintendoClients: "https://github.com/kinnay/NintendoClients/wiki",
  playerId: "https://github.com/kinnay/NintendoClients/wiki/NEX-Common-Types#pid",
  trackId: "https://github.com/kinnay/NintendoClients/wiki/Mario-Kart-8-Track-IDs",
}

const production: Environment = {
  domain: "https://www.mkdatabase.com",
  hyperlinks: hyperlinks,
}

const development: Environment = {
  domain: "http://localhost:3001",
  hyperlinks: hyperlinks,
}

export default process.env.NODE_ENV === "production" ? production : development
